import { performanceContainer } from "../common/perf-container";
performanceContainer.performance = performance;
